import React, { useState } from "react";
import PropTypes from "prop-types";
import ReactDOM from "react-dom";
import { reactLocalStorage } from "reactjs-localstorage";
import "../styles/css/BrightnessProgressBar.scss";
import {
    Modal,
    Button,
    Tooltip,
    Input,
    Icon,
    Radio,
    Popover,
    Menu,
    Avatar,
  } from "antd";
import BrushOffIcon from "mdi-react/BrushIcon";

export default class PenMeeting extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      value: 1,
      current1: "2",
      current2: "red",
	  current3:"",
	  current4:"",
	  current5:reactLocalStorage.get("multiple")?reactLocalStorage.get("multiple"):"20",
	  brightness:50,
	  setBrightness:reactLocalStorage.get("setBrightness")?reactLocalStorage.get("setBrightness"):90,
	  
    };
	
	 
  }
  onChange = (e) => {
    console.log("radio checked", e.target.value);
    this.setState({
      value: e.target.value,
    });
  };
  showModal = () => {
    this.setState({
      visible: true,
    });

    let url = this.props.pen;
    // let host = window.location.host;
    // let url = window.location.protocol + "//" + host + "/?room=" + loginInfo.roomId;
    this.setState({ url });
  };
  handleOk = (e) => {
    this.setState({
      visible: false,
    });
    let aa = ["red", "Green", "Black", "White"];
    // console.log(aa[this.state.value-1])
    sessionStorage.setItem("color", aa[this.state.value - 1]);
    console.log(sessionStorage.getItem("color"));
    // this.props.changeColor(aa[this.state.value-1])
    // this.props.changeColor(aa[this.state.value-1])
  };
  handleCancel = (e) => {
    this.setState({
      visible: false,
    });
  };

  onFocus = (e) => {
    ReactDOM.findDOMNode(e.target).select();
  };
  handleClick1 = (e) => {
    sessionStorage.setItem("pensize", e.key);
    this.setState({
      current1: e.key,
    });
  };
  handleClick2 = (e) => {
    reactLocalStorage.set("color", e.key);
    this.setState({
      current2: e.key,
    });
  };
 
      
  
  handleSliderChange = (event) => {
	 
	   reactLocalStorage.set("setBrightness",event.target.value );
      this.setState({
      setBrightness: (event.target.value)
    }); // 更新亮度值
  }
  handleClick3 = (e) => {
    
  
    this.setState({
      current3: e.key,
    });
  };
  handleClick4 = (e) => {
    
  this.setState({
    current4: e.key,
  });
   
  };
  handleClick5 = (e) => {
    this.setState({
      current5: e.key,
	 
    });
  reactLocalStorage.set("multiple",e.key );
   
  };
  
 
  render() {
    const content = (
      <div>粗细
        <Menu
          onClick={this.handleClick1}
          selectedKeys={[this.state.current1]}
          mode="horizontal"
        >
          <Menu.Item key="2">
            <Icon
              type="line"
              style={{ fontSize: "30px", }}
            />
          </Menu.Item>
          <Menu.Item key="4">
            <Icon
              type="line"
              style={{
                fontSize: "40px",
              }}
            />
          </Menu.Item>
          <Menu.Item key="8">
          <Icon
              type="line"
              style={{ fontSize: "50px",  }}
            />
          </Menu.Item>
          <Menu.Item key="16">
          <Icon
              type="line"
              style={{ fontSize: "60px",}}
            />
          </Menu.Item>
        </Menu>
		
        <br />
		颜色
        <Menu
          onClick={this.handleClick2}
          selectedKeys={[this.state.current2]}
          mode="horizontal"
        >
			<Menu.Item key="red">
			  <Avatar
			    style={{ color: "#f56a00", backgroundColor: "#e31e1f" }}
			  ></Avatar>
			</Menu.Item>
          <Menu.Item key="black">
            <Avatar
              style={{ color: "#f56a00", backgroundColor: "#000000" }}
            ></Avatar>
          </Menu.Item>

          
          <Menu.Item key="orange">
            <Avatar
              style={{ color: "#f56a00", backgroundColor: "#f76509" }}
            ></Avatar>
          </Menu.Item>
          <Menu.Item key="yellow">
            <Avatar
              style={{ color: "#f56a00", backgroundColor: "#f7ba12" }}
            ></Avatar>
          </Menu.Item>
          <Menu.Item key="green">
            <Avatar
              style={{ color: "#f56a00", backgroundColor: "#09be55" }}
            ></Avatar>
          </Menu.Item>
          <Menu.Item key="cyan">
            <Avatar
              style={{ color: "#f56a00", backgroundColor: "#32dab3" }}
            ></Avatar>
          </Menu.Item>
          <Menu.Item key="blue">
            <Avatar
              style={{ color: "#f56a00", backgroundColor: "#056ff9" }}
            ></Avatar>
          </Menu.Item>
          <Menu.Item key="purple">
            <Avatar
              style={{ color: "#f56a00", backgroundColor: "#6136f8" }}
            ></Avatar>
          </Menu.Item>
        </Menu>
		<br />
		透明度
		<Menu
		  onClick={this.handleClick3}
		  selectedKeys={[this.state.current3]}
		  mode="horizontal"
		>
			<Menu.Item key="v">
			  <div className="container">
			              <input
			                  type="range"
			                  min="0"
			                  max="100"
			                  value={this.statebrightness}
			                  onChange={this.handleSliderChange}
			              />
						  
			              <div
			                  className="progress-bar"
			                  style={{ backgroundColor: `rgba(0, 123, 255, ${this.state.brightness / 100})` }}
			              />
			          </div>
			</Menu.Item>
		 
		</Menu>
		<br />
		画笔工具
		<Menu
		  onClick={this.handleClick4}
		  selectedKeys={[this.state.current4]}
		  mode="horizontal"
		>	
		<Menu.Item key="1">
            <Button onClick={() =>this.props.startCaptureCanvas()} >画笔</Button>	
          </Menu.Item>
          <Menu.Item key="2">
            <Button onClick={() =>this.props.drawLine0()}>箭头</Button>
          </Menu.Item>
          <Menu.Item key="3">
          <Button onClick={() =>this.props.drawLineRuler()}>定标</Button>
          </Menu.Item>
          <Menu.Item key="4">
          <Button  onClick={() =>this.props.drawMeasure()}>测量</Button>	
		   </Menu.Item>
		   <Menu.Item key="5">
		   <Button onClick={() =>this.props.drawLineRuler2()}>标尺</Button>		
		    </Menu.Item>
			<Menu.Item key="6">
			<Button onClick={() =>this.props.onBroomClickHandler()}>清除</Button>		
			 </Menu.Item>
		 
		</Menu>
		<br />
		显微镜物镜倍数
		<Menu
		  onClick={this.handleClick5}
		  selectedKeys={[this.state.current5]}
		  mode="horizontal"
		>	
		<Menu.Item key="4">
		    <Button  >4倍</Button>	
		  </Menu.Item>
		  <Menu.Item key="10">
		    <Button >10倍</Button>
		  </Menu.Item>
		  <Menu.Item key="20">
		  <Button >20倍</Button>
		  </Menu.Item>
		  <Menu.Item key="40">
		  <Button  >40倍</Button>	
		   </Menu.Item>
		   
		  
		 
		</Menu>
      </div>
    );
    return (
      <div className="app-header-tool-container">
        <Tooltip >
          <Popover content={content}>
            <Button ghost size="large" type="link" >
              <Icon
                component={this.state.Brush ? BrushIcon : BrushOffIcon}
                style={{ display: "flex", justifyContent: "center" }}
              />
              <p>画笔</p>
            </Button>
          </Popover>
        </Tooltip>
        <Modal
          title="选择颜色"
          visible={this.state.visible}
          onOk={this.handleOk}
          onCancel={this.handleCancel}
          okText="OK"
          cancelText="Cancel"
        >
          <div>
            <div>
              <Radio.Group onChange={this.onChange} value={this.state.value}>
                <Radio value={1}>
                  <span>红色</span>{" "}
                  <p
                    style={{
                      width: "20px",
                      height: "20px",
                      background: "red",
                      display: "inline",
                    }}
                  ></p>
                </Radio>
                <Radio value={2}>
                  <span>绿色</span>{" "}
                  <span
                    style={{ width: "20px", height: "20px", background: "red" }}
                  ></span>
                </Radio>
                <Radio value={3}>
                  <span>黑色</span>{" "}
                  <span
                    style={{ width: "20px", height: "20px", background: "red" }}
                  ></span>
                </Radio>
                <Radio value={4}>
                  <span>白色</span>{" "}
                  <span
                    style={{ width: "20px", height: "20px", background: "red" }}
                  ></span>
                </Radio>
              </Radio.Group>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

PenMeeting.propTypes = {
  roomInfo: PropTypes.any,
};
